export const fillapplicationCn = {
    qsrxgxx:"请输入相关信息",
    fjxz:"附件下载",
    jcxxx:"检测项信息",
    qtzl:"其他资料：",
    dqjcxjg:"当前所选检测项目价格：",
    qrbtj:"确认并提交"
}


// WEBPACK FOOTER //
// ./src/lang/home/selfHelpFillapplication/indexCn.js